import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { getSystem } from '../../system';
import { extendAtomProps, filterAllowedAtoms } from '../../system/utils';

var warnNotAllowedProps = function warnNotAllowedProps(clonableProps, usedProps, displayName) {
  Object.keys(usedProps).forEach(function (cleanProp) {
    if (!clonableProps.includes(cleanProp)) {
      // eslint-disable-next-line
      console.warn("Box clone: \"" + cleanProp + "\" is not allowed in \"" + displayName + "\".");
    }
  });
};
/**
 * Use React.cloneElement and pass only allowedProps to the child component.
 *
 * @param {Object} allPropsObj - All props available in Box
 * @param {Node} children - Box children
 * @param {string} className - Css class
 * @param {Object} rest - Spread props object
 * @param {Object} style - Style object
 * @param {usedProps} - The active used props object
 *
 * @returns - React.cloneElement with filtered props
 *
 * @example
 * createCloneChildren({ children, className, usedProps, allPropsObj, rest, style });
 */


var createCloneChildren = function createCloneChildren(_ref) {
  var allPropsObj = _ref.allPropsObj,
      children = _ref.children,
      className = _ref.className,
      rest = _ref.rest,
      style = _ref.style,
      usedProps = _ref.usedProps;
  return React.Children.map(children, function (child) {
    // Get clonableProps of the child component -> doesn't mean they are passed by Box (it's just possible)
    var clonableProps = child.type.clonableProps ? extendAtomProps(child.type.clonableProps) // Extend props with aliases e.g. m -> mx, mb, ...
    : []; // Warn when prop is not allowed in the child component

    warnNotAllowedProps(clonableProps, usedProps, child.type.displayName); // Remove not allowed props from props passed to the child component

    var clonedPropsObj = filterAllowedAtoms(allPropsObj, clonableProps); // Create atom classNames & styles

    var _getSystem = getSystem(_extends({}, clonedPropsObj, {
      className: className,
      style: style
    })),
        allowedClassnames = _getSystem[0],
        allowedStyles = _getSystem[1];

    return /*#__PURE__*/React.cloneElement(child, _extends({
      style: allowedStyles,
      className: allowedClassnames
    }, rest), child.props.children);
  });
};

export default createCloneChildren;